/**
 * Host-page `dataLayer` integration for GTM → GA4. Creates `window.dataLayer` when absent; wraps `push` in
 * try/catch so missing analytics or strict environments do not break the widget.
 */

/**
 * Which one-shot listener fired first. Mirrored in `ece_intent_gate_impression` (gate shown) and
 * `ece_modal_impression` (full-page quiz opened after “Take the Quiz”).
 */
export type EceModalTrigger = 'scroll_depth' | 'exit_intent' | 'mobile_scroll_exit';

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/** Returns the host `dataLayer` array, or a throwaway empty array during SSR. */
function getDataLayer(): Record<string, unknown>[] {
  if (typeof window === 'undefined') {
    return [];
  }
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  return window.dataLayer;
}

/**
 * Queues one object for GTM. Use `{ event: 'custom_name', ...params }` so GTM Custom Event triggers match.
 */
export function pushDataLayer(payload: Record<string, unknown>): void {
  try {
    getDataLayer().push(payload);
  } catch {
    /* ignore host restrictions */
  }
}
